<template lang="pug">
  
  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-lg-12
        .ibox.float-e-margins
          .ibox-title
            .ibox-tools
              router-link(:to="{ name: 'Dashboard-Condo-Name-Create' }").btn.btn-link <i class="fa fa-plus"></i> Add Project Name
          
          .ibox-content
            .row(v-show="loading")
              .col-xs-12
                h1 Loading...
            .table-responsive
              //- table.table.table-striped
                thead
                  tr
                    th PROJECT NAME
                    th LOCATION
                    th(width="100") CREATE
                    th(width="100") UPDATE
                    th(style="width:150px;")
                tbody
                  tr(v-for="name in projectsName")
                    td {{ name.title ? name.title : '-' }}
                    td: .td-location {{ name.location ? name.location : '-' }}
                    td {{ name.create_by ? name.create_by : '-' }} <small>{{ name.create_date ? formatDate(name.create_date) : '-' }}</small>
                    td {{ name.update_by ? name.update_by : '-' }} <small>{{ name.update_date ? formatDate(name.update_date) : '-' }}</small>
                    td.text-right
                      router-link.btn.btn-default.btn-xs(:to="{ name: 'Dashboard-Condo-Name-Edit', params: { id: name.id }}") Edit
                      | &nbsp;&nbsp;&nbsp;
                      button.btn.btn-xs(:class="name.del_flag == '0' ? 'btn-warning' : 'btn-primary'" type="button" @click="onDelete({ id: name.id, flag: name.del_flag })")
                        span(v-show="name.del_flag == '0'") Delete
                        span(v-show="name.del_flag == '1'") Restore

              .project_table
                .table_head
                  .td-name PROJECT NAME
                  .td-location LOCATION
                  .td-create CREATE
                  .td-update UPDATE
                  .td-action

                .table_body(v-for="name in projectsName")
                  .td-name {{ name.title ? name.title : '-' }}
                  .td-location {{ name.location ? name.location : '-' }}
                  .td-create {{ name.create_by ? name.create_by : '-' }} <small>{{ name.create_date ? formatDate(name.create_date) : '-' }}</small>
                  .td-update {{ name.update_by ? name.update_by : '-' }} <small>{{ name.update_date ? formatDate(name.update_date) : '-' }}</small>
                  .td-action.text-right
                    router-link.btn.btn-default.btn-xs(:to="{ name: 'Dashboard-Condo-Name-Edit', params: { id: name.id }}") Edit
                    | &nbsp;&nbsp;&nbsp;
                    button.btn.btn-xs(:class="name.del_flag == '0' ? 'btn-warning' : 'btn-primary'" type="button" @click="onDelete({ id: name.id, flag: name.del_flag })")
                      span(v-show="name.del_flag == '0'") Delete
                      span(v-show="name.del_flag == '1'") Restore



</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'

  export default {
    data () {
      return {
        loading: false,
        projectsName: []
      }
    },
    created () {
      this.fetchProjectsName()
    },
    methods: {
      formatDate (datetime) {
        return moment(datetime).format('D MMM YYYY')
      },
      fetchProjectsName () {
        this.loading = true
        this.projectsName = []
        axios.get('project/title').then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.projectsName = res.data.data
              console.log(this.projectsName)
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
          this.loading = false
        })
      },
      onDelete (data) {
        var _this = this
        swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: data.flag === '0' ? 'Delete!' : 'Restore!',
          cancelButtonText: 'No'
        }).then(function () {
          if (data.flag === '0') {
            axios.delete(`project/title/id/${data.id}`).then((res) => {
              switch (res.data.responseCode) {
                case 200:
                  swal(
                    'Deleted!',
                    'Project name has been deleted.',
                    'success'
                  )
                  break
                case 405:
                  toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                case 406:
                  toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                default:
                  console.log(res.data.message)
              }
              _this.fetchProjectsName()
            })
          } else {
            axios.put(`project/title/id/${data.id}`).then((res) => {
              switch (res.data.responseCode) {
                case 200:
                  swal(
                    'Restored!',
                    'Project name has been restored.',
                    'success'
                  )
                  break
                case 405:
                  toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                case 406:
                  toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                default:
                  console.log(res.data.message)
              }
              _this.fetchProjectsName()
            })
          }
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              data.flag === '0' ? 'Project name still gone :(' : 'Project name is safe :)',
              'error'
            )
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

  .project_table {
    min-width: 1000px;
    
    .table_head {
      float: left;
      width: 100%;
      font-weight: bold;
      padding-bottom: 10px;
      font-size: 14px;

      @media (max-width: 1300px) {
        width: 1000px;
      }
    }

    .table_body {
      float: left;
      width: 100%;

      &:nth-child(even) {
        background-color: #efefef;
      }

      @media (max-width: 1300px) {
        width: 1000px;
      }
    }

    .td-name {
      float: left;
      width: 25%;
      padding: 5px 10px;
    }

    .td-location {
      float: left;
      width: 40%;
      padding: 5px 10px;
      overflow: hidden;
      word-wrap: break-word;
      white-space: nowrap;
      text-overflow: ellipsis;

      @media(max-width: 425px) {
        max-width: 200px;
      }
    }

    .td-create, .td-update {
      float: left;
      width: 10%;
      padding: 5px 10px;
    }

    .td-action {
      float: left;
      width: 15%;
      padding: 5px 10px;
    }
  }
</style>




// WEBPACK FOOTER //
// index.vue?0547dbbd